/* eslint-disable @typescript-eslint/ban-ts-comment */

export const analytics = {
  gtag: {
    event: (action: string, params?: Record<string, unknown>) => {
      if (process.env.MODE === 'local') return;
      // @ts-ignore
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        console.log('analytics:', action, params);

        // @ts-ignore
        window.dataLayer.push({ event: action, ...params });
      } else {
        console.log('%cNo dataLayer array on window object', 'color: red');
      }
    },
  },
};
